(() => {
    const packPreferenceBySection = (window.__tdPackPreferenceBySection =
      window.__tdPackPreferenceBySection || {});
    const DEAL_PROPERTY_KEYS = {
      active: '_td_deal_active',
      code: '_td_deal_code',
      requiredQty: '_td_deal_required_qty',
      freeShipping: '_td_deal_is_free_shipping',
    };
  
    const bindTdVariantPicker = (variantSelects) => {
      if (!variantSelects || variantSelects.dataset.tdPackBound === 'true') return;
  
      variantSelects.dataset.tdPackBound = 'true';
      const sectionId = variantSelects.dataset.section;
      const dealsActive = variantSelects.dataset.tdDealsActive === 'true';
  
      const getProductForm = () => {
        const formId = variantSelects.dataset.productFormId;
        return formId ? document.getElementById(formId) : null;
      };
  
      const getSelectedPackQuantity = () => {
        const selectedInputs = variantSelects.querySelectorAll('input.td-variant-picker__input:checked');
        for (const selectedInput of selectedInputs) {
          const packQuantity = Number.parseInt(selectedInput.dataset.tdPackQuantity || '1', 10) || 1;
          if (packQuantity > 1) return packQuantity;
        }
        return 1;
      };
  
      const getPrimarySelectedInput = () => {
        const selectedInputs = Array.from(variantSelects.querySelectorAll('input.td-variant-picker__input:checked'));
        if (!selectedInputs.length) return null;
        return (
          selectedInputs.find((input) => (Number.parseInt(input.dataset.tdPackQuantity || '1', 10) || 1) > 1) ||
          selectedInputs[0]
        );
      };
  
      const ensureQuantityInput = (productForm, createIfMissing = false) => {
        if (!productForm) return null;
  
        let quantityInput = productForm.querySelector('input[name="quantity"]');
        if (!quantityInput && createIfMissing) {
          quantityInput = document.createElement('input');
          quantityInput.type = 'hidden';
          quantityInput.name = 'quantity';
          quantityInput.dataset.tdPackCreated = 'true';
          productForm.appendChild(quantityInput);
        }
  
        return quantityInput;
      };

      const ensureDealPropertyInput = (productForm, propertyKey) => {
        if (!productForm || !propertyKey) return null;

        let propertyInput = productForm.querySelector(`input[data-td-deal-property-key="${propertyKey}"]`);
        if (!propertyInput) {
          propertyInput = document.createElement('input');
          propertyInput.type = 'hidden';
          propertyInput.name = `properties[${propertyKey}]`;
          propertyInput.dataset.tdDealPropertyKey = propertyKey;
          productForm.appendChild(propertyInput);
        }

        return propertyInput;
      };

      const removeDealPropertyInput = (productForm, propertyKey) => {
        if (!productForm || !propertyKey) return;
        const propertyInput = productForm.querySelector(`input[data-td-deal-property-key="${propertyKey}"]`);
        if (propertyInput) propertyInput.remove();
      };

      const setDealPropertyValue = (productForm, propertyKey, propertyValue) => {
        if (!productForm || !propertyKey) return;

        if (typeof propertyValue !== 'string' || propertyValue.trim() === '') {
          removeDealPropertyInput(productForm, propertyKey);
          return;
        }

        const propertyInput = ensureDealPropertyInput(productForm, propertyKey);
        if (!propertyInput) return;
        propertyInput.value = propertyValue.trim();
      };

      const clearDealProperties = (productForm) => {
        if (!productForm) return;
        removeDealPropertyInput(productForm, DEAL_PROPERTY_KEYS.active);
        removeDealPropertyInput(productForm, DEAL_PROPERTY_KEYS.code);
        removeDealPropertyInput(productForm, DEAL_PROPERTY_KEYS.requiredQty);
        removeDealPropertyInput(productForm, DEAL_PROPERTY_KEYS.freeShipping);
      };

      const applyInitialDealDefault = () => {
        if (Object.prototype.hasOwnProperty.call(packPreferenceBySection, sectionId)) {
          return;
        }

        let maxPack = 1;
        variantSelects.querySelectorAll('fieldset.product-form__input').forEach((fieldset) => {
          const defaultDealInput = fieldset.querySelector(
            'input.td-variant-picker__input[data-td-select-deal-default="true"]:not(:disabled)'
          );
          if (!defaultDealInput) return;

          defaultDealInput.checked = true;
          const pack =
            Number.parseInt(defaultDealInput.dataset.tdPackQuantity || '2', 10) || 2;
          if (pack > maxPack) maxPack = pack;
        });

        packPreferenceBySection[sectionId] = maxPack;
      };

      const restorePackSelection = () => {
        const preferredPackQuantity = Number.parseInt(packPreferenceBySection[sectionId] || 1, 10) || 1;
        if (preferredPackQuantity <= 1) return;
  
        variantSelects.querySelectorAll('fieldset.product-form__input').forEach((fieldset) => {
          const selectedInput = fieldset.querySelector('input.td-variant-picker__input:checked');
          if (!selectedInput || (Number.parseInt(selectedInput.dataset.tdPackQuantity || '1', 10) || 1) > 1) return;
  
          const dealInput = fieldset.querySelector(
            `input.td-variant-picker__input[data-td-pack-quantity="${preferredPackQuantity}"][data-option-value-id="${selectedInput.dataset.optionValueId}"]`
          );
  
          if (dealInput) {
            dealInput.checked = true;
          }
        });
      };
  
      const applySelectedPackQuantity = () => {
        const productForm = getProductForm();
        if (!productForm) return;
  
        const selectedPackQuantity = getSelectedPackQuantity();
        packPreferenceBySection[sectionId] = selectedPackQuantity;
        document.dispatchEvent(
          new CustomEvent('td:pack-quantity-changed', {
            detail: {
              sectionId,
              packQuantity: selectedPackQuantity,
            },
          })
        );
        const quantityInput = ensureQuantityInput(productForm, selectedPackQuantity > 1);
        if (!quantityInput) return;
  
        if (selectedPackQuantity > 1) {
          quantityInput.value = String(selectedPackQuantity);
          return;
        }
  
        if (quantityInput.dataset.tdPackCreated === 'true') {
          quantityInput.remove();
        }
      };

      const syncDealLineItemProperties = () => {
        const productForm = getProductForm();
        if (!productForm) return;

        if (!dealsActive) {
          clearDealProperties(productForm);
          return;
        }

        const selectedInput = getPrimarySelectedInput();
        if (!selectedInput) {
          clearDealProperties(productForm);
          return;
        }

        const associatedDealCode = selectedInput.dataset?.tdAssociatedDealCode?.trim() || '';
        const associatedDealRequiredQty =
          Number.parseInt(selectedInput.dataset?.tdAssociatedDealRequiredQty || '1', 10) || 1;
        const associatedIsFreeShipping = selectedInput.dataset?.tdAssociatedIsFreeShipping === 'true';

        if (!associatedIsFreeShipping) {
          clearDealProperties(productForm);
          return;
        }

        setDealPropertyValue(productForm, DEAL_PROPERTY_KEYS.active, 'true');
        setDealPropertyValue(productForm, DEAL_PROPERTY_KEYS.code, associatedDealCode);
        setDealPropertyValue(
          productForm,
          DEAL_PROPERTY_KEYS.requiredQty,
          associatedDealRequiredQty > 0 ? String(associatedDealRequiredQty) : ''
        );
        setDealPropertyValue(productForm, DEAL_PROPERTY_KEYS.freeShipping, 'true');
      };
  
      const syncTdButtonPricingFromSelectedCard = () => {
        const productForm = getProductForm();
        if (!productForm) return;
  
        const selectedInput = getPrimarySelectedInput();
        if (!selectedInput) return;
  
        const selectedCard = variantSelects.querySelector(`label[for="${selectedInput.id}"]`);
        if (!selectedCard) return;
  
        const buttonPrice = productForm.querySelector('[data-td-button-price]');
        const buttonCompare = productForm.querySelector('[data-td-button-compare]');
        if (!buttonPrice) return;
  
        const selectedCardPrice = selectedCard.querySelector('.td-variant-picker__price');
        const selectedCardCompare = selectedCard.querySelector('.td-variant-picker__compare');
  
        if (selectedCardPrice) {
          buttonPrice.textContent = selectedCardPrice.textContent.trim();
        }
  
        if (buttonCompare) {
          const shouldShowCompare = Boolean(selectedCardCompare && !selectedCardCompare.hasAttribute('hidden'));
          buttonCompare.textContent = shouldShowCompare ? selectedCardCompare.textContent.trim() : '';
          buttonCompare.hidden = !shouldShowCompare;
        }
      };
  
      variantSelects.addEventListener('change', applySelectedPackQuantity);
      variantSelects.addEventListener('change', () => {
        syncTdButtonPricingFromSelectedCard();
        syncDealLineItemProperties();
      });
      getProductForm()?.addEventListener('submit', () => {
        applySelectedPackQuantity();
        syncDealLineItemProperties();
      });
      applyInitialDealDefault();
      restorePackSelection();
      applySelectedPackQuantity();
      syncTdButtonPricingFromSelectedCard();
      syncDealLineItemProperties();
    };
  
    const initTdVariantPickers = () => {
      document.querySelectorAll('variant-selects.td-variant-picker').forEach(bindTdVariantPicker);
    };
  
    initTdVariantPickers();
    document.addEventListener('shopify:section:load', () => {
      initTdVariantPickers();
    });
    document.addEventListener('variant:changed', () => {
      setTimeout(initTdVariantPickers, 0);
    });
})();
